// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__1KtsT","footer":"ModalError_footer__3TB0Z"};